import ReactDOM from "react-dom";
import App from "./App";
import "antd/dist/antd.css"
import React from "react";
import "./index.scss";
// import "../polyfill";


ReactDOM.render(
    <App />,
    document.getElementById('root')
);